var OrderItemModel = /** @class */ (function () {
    function OrderItemModel(customerProduct, quantity) {
        this.quantity = 0;
        this.product = customerProduct;
        this.quantity = quantity !== null && quantity !== void 0 ? quantity : 0;
        this.extraServices = customerProduct.extraServices.map(function (es) { return ({
            code: es.code,
            price: es.price,
            isSelected: false,
        }); });
    }
    return OrderItemModel;
}());
export { OrderItemModel };
var ExtraServiceModel = /** @class */ (function () {
    function ExtraServiceModel() {
    }
    return ExtraServiceModel;
}());
export { ExtraServiceModel };
